export const USERS_ACTIONS_TYPES = {
  SET_TABLE_DATA: 'SET_TABLE_DATA',
  SET_LOADING: 'SET_LOADING',
  SET_FAILURE: 'SET_FAILURE',
  SET_STATUS_COUNT_LOADING: 'SET_STATUS_COUNT_LOADING',
  SET_STATUS_COUNT: 'SET_STATUS_COUNT',
  SET_STATUS_COUNT_FAILURE: 'SET_STATUS_COUNT_FAILURE',
}

export const USERS_INITIAL_STATE = {
  data: [],
  search: {},
  nextPageToken: null,
  loading: false,
  msLoaded: false,
  error: false,
  statusCount: { confirmed: 0, unconfirmed: 0, reset_required: 0, total: 0 },
  statusCountLoading: false,
}
